import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import CreateClassLink from "../CreateClassLink/CreateClassLink";
import axios from "../../../axios";
import { SubStdSelContext } from "../../../SubStdSelContext";
import "../../styles/index.css";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import YoutubeLiveLink from "../YoutubeLiveLink";
import { hasFeature } from "../../../Utils/features";

/**
 * Displays AddClassMaterial for day view
 * @param {*} param0
 * @returns
 * @param {*} param0
 * @returns
 */

const mapStateToProps = (state) => ({
  inc: state.redres,
  dec: state.redres1,
  ovr: state.redres2,
});

const Upcoming = ({
  event,
  inc,
  dec,
  ovr,
  refetch1,
  SDate,
  EDate,
  setIsCreateLinkClicked,
  hasLiveLecture,
}) => {

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );

  const general_role = localStorage.getItem("general_role");
  const jsonRole_Geinformation = JSON.parse(general_role);
  const navigate = useNavigate();
  const { secSelectedOption, stdSelectedOption, teacherDCM } =
    useContext(SubStdSelContext);
  const [click1, setClick1] = useState(false);
  const [joinNow, setJoinNow] = useState(false);
  const [editfunction, setEditFunction] = useState(false);
  const [bookChapterList, setBookChapterList] = useState([]);

  const schoolInfo = JSON.parse(localStorage.getItem("UserInformation"));



  const onClassMaterialClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    if (teacherDCM === "option3") {
      jsonRole_Geinformation.forEach((element) => {
        if (element.standard_id.id === inc.id) {
          if (element.section_id.id === dec.id) {
            element.subjects_id.forEach((element) => {
              if (element.name === event.Subject) {
                setEditFunction(true);
              } else {
                setEditFunction(false);
              }
            });
          }
        }
      });
    } else {
      setEditFunction(true);
    }
    event.Events.forEach((element) => {
      if (element.name === "bbb_lecture") {
        setJoinNow(true);
      }
    });
  }, [event]);

  const joinnow_helper = async () => {
    let teacherJoinLink = await onJoinNowClick();
    navigate(teacherJoinLink);
  };
  let _id;
  const onJoinNowClick = async () => {
    const viewer_name = JSON.parse(localStorage.getItem("UserName"));
    event.Events.forEach((element) => {
      if (element.name === "bbb_lecture") {
        setJoinNow(true);
        _id = element.value;
      }
    });
    try {
      const res = await axios.get(
        `/api/v1/videoConference/classes/start/${_id}?moderator_name=${viewer_name}`,
      );
      if (res.data.status === true) {
        return res.data.data;
      }
    } catch (error) {
      error.response.data.status === false && console.log(error);
    }
  };
  const getDetails = async () => {
    try {
      let chapters = await axios.get(
        `/api/v1/cm/library/book/getBookByClassSectionSubject?standard_id=${stdSelectedOption}&section_id=${secSelectedOption}&subject_id=${event.Subject_id}&timetableSessionId=${timeTableSessionId}`,
      );
      if (chapters) {
        setBookChapterList(chapters.data.data[0].bookInfo);
      }
    } catch (error) {
      console.log(error);
      // toast.error("Something went wrong while books and chapter fetching");
    }
  };

  const standardsName = localStorage.getItem("stdSelectionName");
  const sectionName = localStorage.getItem("secSelectionName");

  useEffect(() => {
    getDetails();
  }, [click1]);

  const has2WayLecture =
    hasFeature("OL_LEC_2W_NR") || hasFeature("OL_LEC_2W_WR");

  const has1WayLecture =
    hasFeature("OL_LEC_1W_NR") || hasFeature("OL_LEC_1W_WR");

  const hasAnyOnlineLecture = has1WayLecture || has2WayLecture;

  const lectureMode = has2WayLecture ? "2WAY" : has1WayLecture ? "1WAY" : null;


  return (
    <>
      <div className=" summary_con col gap-4">
        {hasFeature("LEC_SUM") && (
          <div
            onClick={() => {
              localStorage.setItem("liveSession", JSON.stringify(event));
              let obj = {
                standard_id: inc.id,
                standardName: inc.name,
                section_id: dec.id,
                sectionName: dec.name,
              };
              localStorage.setItem("std", JSON.stringify(obj));
              localStorage.setItem("from", "DCM");
            }}
          >
            <NavLink
              className="link"
              to={`/liveSession`}
              state={{
                supplement_id: event.Supplement_id,
                standard_id: stdSelectedOption,
                section_id: secSelectedOption,
                lecture_id: event.Id,
                scheduled_date: event.StartTime,
                standardsName: standardsName,
                sectionName: sectionName,
              }}
            >
              {editfunction && <div className="">Add Material</div>}
            </NavLink>
          </div>
        )}
        <div
          className="d-flex justify-content-end"
          style={{ cursor: "pointer" }}
        >
          {editfunction &&
            !hasLiveLecture &&
            hasAnyOnlineLecture &&
            (event?.Events?.some((item) => item.name === "bbb_lecture") ? (
          <img
                className="dcm-share-img"
                src="/images/classCreated.svg"
              onClick={() => {
                setClick1(true);
                setIsCreateLinkClicked(true);
              }}
              alt=""
              />
            ) : (
                <button
              onClick={() => {
                setClick1(true);
                setIsCreateLinkClicked(true);
              }}
              className="btn d-flex align-items-center justify-content-center px-2 py-1 fw-bold text-uppercase shadow-sm"
              style={{
                backgroundColor: "#fff",
                color: "#695078",
                border: "2px solid #4169e1",
                borderRadius: "50px",
                fontSize: "9px",
                transition: "all 0.3s ease",
                cursor: "pointer",
              }}
            >
              Create Online Class
            </button>
            ))}
        </div>
      </div>
      {click1 &&
        (lectureMode === "2WAY" ? (
          <CreateClassLink
            setClick1={setClick1}
            event={event}
            refetch2={refetch1}
            SDate={SDate}
            EDate={EDate}
            bookChapterList={bookChapterList}
          />
        ) : lectureMode === "1WAY" ? (
          <YoutubeLiveLink
            setClick1={setClick1}
            event={event}
            refetch2={refetch1}
            SDate={SDate}
            EDate={EDate}
            bookChapterList={bookChapterList}
          />
        ) : null)}
    </>
  );
};
export default connect(mapStateToProps)(Upcoming);
